export const INITIAL_SPECIES_HIGHLIGHT_COUNT = 6;
export const INITIAL_MEDIA_COUNT = 8;
export const HOTSPOT_DETAIL_TABS = ['overview', 'species', 'media'] as const;
export const HOTSPOT_HABITAT_FALLBACK_COLOR = '#8f9d8a';
export const HOTSPOT_HERO_COMPACT_TITLE_LENGTH = 60;

export const HOTSPOT_HABITAT_COLORS: Record<string, string> = {
    water: '#6ea8c7',
    open_water: '#6ea8c7',
    permanent_water_bodies: '#6ea8c7',
    forest: '#2f6f55',
    tree_cover: '#2f6f55',
    forest_woodland: '#2f6f55',
    grassland: '#7ea66b',
    grassland_open_country: '#7ea66b',
    shrubland: '#8fa56a',
    shrubland_scrub: '#8fa56a',
    wetland: '#4f9b97',
    mangrove_wetland: '#4f9b97',
    wetland_mangrove: '#4f9b97',
    herbaceous_wetland: '#4f9b97',
    mangroves: '#4f9b97',
    agricultural: '#c9a227',
    cropland: '#c9a227',
    developed: '#7e8b96',
    urban_developed: '#7e8b96',
    built_up: '#7e8b96',
    bare_sparse: '#b4ab97',
    bare_sparse_vegetation: '#b4ab97',
    moss_and_lichen: '#b4ab97',
    tundra_moss_lichen: '#b4ab97'
};

export function getHotspotHabitatColor(keyOrLabel: string) {
    const normalizedKey = keyOrLabel
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^\w]+/g, '_')
        .replace(/^_+|_+$/g, '');

    return HOTSPOT_HABITAT_COLORS[normalizedKey] ?? HOTSPOT_HABITAT_FALLBACK_COLOR;
}

export const HOTSPOT_CONSERVATION_ITEMS = [
    {
        label: 'Protected lands',
        value: 'Not yet connected',
        detail: 'Placeholder until local conservation overlays are wired into hotspot detail.'
    },
    {
        label: 'IBA / KBA',
        value: 'Not yet connected',
        detail: 'This section is intentionally mocked for now.'
    },
    {
        label: 'Priority habitat',
        value: 'Pending data',
        detail: 'Habitat context is shown above; conservation prioritization still needs a source.'
    }
] as const;

export const HOTSPOT_HABITAT_FEEDBACK_SOMETHING_ELSE = '__something_else__';

export const HOTSPOT_HABITAT_RULE_GROUP_ORDER = [
    'Forest',
    'Grassland',
    'Shrubland',
    'Wetland',
    'Water',
    'Coastal',
    'Mountain',
    'Desert',
    'Agricultural',
    'Urban',
    'Mixed'
] as const;
